import axios from "axios";

// Function to handle login API request
export const loginUser = async (payload) => {
  try {
    const response = await axios.post("https://c-greenproject.org:7500/login", payload, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, // If backend uses cookie-based sessions
    });

    return response.data; // Return the response to the calling component
  } catch (error) {
    if (error.response) {
      console.error("Error:", error.response.data);
      throw new Error(error.response.data.error || "Login failed");
    } else {
      console.error("Unexpected Error:", error.message);
      throw new Error("Unexpected Error");
    }
  }
};

// Function to handle forgot password (lupa_sandi) API request
export const lupaSandi = async (payload) => {
  try {
    // Make a POST request to the lupa_sandi endpoint
    const response = await axios.post("https://c-greenproject.org:7500/lupa_sandi", payload, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, // If backend uses cookie-based sessions
    });

    return response.data; // Return the response data (message or other info)
  } catch (error) {
    if (error.response) {
      console.error("Error:", error.response.data);
      throw new Error(error.response.data.message || "Failed to send password recovery email");
    } else {
      console.error("Unexpected Error:", error.message);
      throw new Error("Unexpected Error");
    }
  }
};
